/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskLogEntryData
 */
export interface TaskLogEntryData {
    /**
     * 
     * @type {number}
     * @memberof TaskLogEntryData
     */
    level: number;
    /**
     * 
     * @type {string}
     * @memberof TaskLogEntryData
     */
    message: string;
}

export function TaskLogEntryDataFromJSON(json: any): TaskLogEntryData {
    return TaskLogEntryDataFromJSONTyped(json, false);
}

export function TaskLogEntryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskLogEntryData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'level': json['level'],
        'message': json['message'],
    };
}

export function TaskLogEntryDataToJSON(value?: TaskLogEntryData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'level': value.level,
        'message': value.message,
    };
}


